import { Store } from '@ngrx/store';

import { SidebarCommandProps, SidebarCustomCommandProps } from '../../domain/models/sidebar.models';
import { SidebarActionTypes } from '../state/sidebar.actions';

import { FeatureCommandHandlerAdapter } from '@core/infrastructure/features/command-handler.adapter';

export const SidebarCommands = {
    OPEN_SIDEBAR_CUSTOM: SidebarActionTypes.OPEN_SIDEBAR_CUSTOM,
    OPEN_SIDEBAR: SidebarActionTypes.OPEN_SIDEBAR,
};

export class SidebarCommand extends FeatureCommandHandlerAdapter<SidebarCommandProps> {
    constructor(public store: Store) {
        super(store);
    }
}

export class SidebarCustomCommand extends FeatureCommandHandlerAdapter<SidebarCustomCommandProps> {
    constructor(public store: Store) {
        super(store);
    }
}

export class LoadSidebarCommand extends FeatureCommandHandlerAdapter<SidebarCustomCommandProps> {
    public static readonly LOAD_SIDEBAR = SidebarActionTypes.LOAD_SIDEBAR;
}
